import React from 'react';
import { Link } from 'react-router-dom';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaWhatsapp } from 'react-icons/fa';

import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
  <footer className="footer">
    <div className="container">

      {/* Footer Content Grid */}
      <div className="footer-content">

        {/* About */}
        <div className="footer-section about">
          <h2 className="footer-title">Global Business Combine</h2>
          <p>
            Your trusted partner for high-quality tungsten carbide dies, diamond tools, and abrasives. 
            With over three decades of experience, we are committed to innovation and excellence.
          </p>
          <a
            href="https://maps.app.goo.gl/6fLXx5ANMXicTPw3A?g_st=aw"
            target="_blank"
            rel="noopener noreferrer"
            className="maps-link"
          >
            📍 View Our Location on Google Maps
          </a>
        </div>

        {/* Quick Links */}
        <div className="footer-section links">
          <h2 className="footer-title">Quick Links</h2>
          <ul className="footer-links">
            <li><Link to="/" className="footer-link">Home</Link></li>
            <li><Link to="/about" className="footer-link">About Us</Link></li>
            <li><Link to="/products" className="footer-link">Products</Link></li>
            <li><Link to="/contact" className="footer-link">Contact Us</Link></li>
          </ul>

          {/* <a
            href="https://drive.google.com/file/d/1mQe5U6VOFngkrss2H2a8duYqDujtJ-mZ/view"
            target="_blank"
            rel="noopener noreferrer"
            className="catalogue-download-btn"
          >
            View Our Catalogue
          </a> */}
        </div>

        {/* Contact */}
        <div className="footer-section contact">
          <h2 className="footer-title">Contact Us</h2>
          <div className="contact-info">

            <div className="contact-item">
              <FaWhatsapp className="contact-icon" />
              <a
                href="https://wa.me/919824083662"
                target="_blank"
                rel="noopener noreferrer"
                className="contact-link"
              >
                +91 982-408-3662
              </a>
            </div>

            <div className="contact-item">
              <FaPhoneAlt className="contact-icon" />
              <a href="tel:25452826" className="contact-link">
                079-25452826
              </a>
            </div>

            <div className="contact-item">
              <FaEnvelope className="contact-icon" />
              <a href="mailto:globalbc@rediff.com" className="contact-link">
                globalbc@rediff.com
              </a>
            </div>

            <div className="contact-item">
              <FaMapMarkerAlt className="contact-icon" />
              <span>
                121, Maheshwari Industrial Estate, Tavdipura, Dudheshwar Road, Ahmedabad, Gujarat
              </span>
            </div>

          </div>
        </div>

      </div> {/* ✅ footer-content closed properly */}

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <p>&copy; {currentYear} Global Business Combine. All rights reserved.</p>
        <div className="footer-bottom-links">
          <Link to="/privacy-policy" className="bottom-link">Privacy Policy</Link>
          <Link to="/terms-of-service" className="bottom-link">Terms of Service</Link>
        </div>
      </div>

    </div>
  </footer>
);

};

export default Footer;
